import axios from "axios";
import { MYREWARDS } from "./url";
import { myRewardsToken } from "../components/auth/auth";

const axios_myrewards = axios.create({
    baseURL: MYREWARDS,
});


const isTokenExpired = (tokenData) => {
    if (!tokenData) return true;

    try {
        const { expires_at } = JSON.parse(tokenData);
        return !expires_at || expires_at <= Math.floor(Date.now() / 1000);
    } catch (e) {
        console.error("Failed to parse token:", e);
        return true;
    }
};


let isRefreshing = false;
let refreshPromise = null;


const refreshToken = async () => {
    if (isRefreshing) return refreshPromise;

    isRefreshing = true;

    refreshPromise = (async () => {
        try {
            const internalToken = await myRewardsToken();

            if (!internalToken?.access_token) {
                throw new Error("Invalid token response");
            }

            const tokenToStore = {
                access_token: internalToken.access_token,
                expires_at: Math.floor(Date.now() / 1000) + (internalToken.expires_in || 3600),
            };

            localStorage.setItem("token_rewards", JSON.stringify(tokenToStore));

            return tokenToStore.access_token;
        } catch (error) {
            console.error("Token refresh failed:", error);
            localStorage.removeItem("token_rewards");
            throw error;
        } finally {
            isRefreshing = false;
        }
    })();

    return refreshPromise;
};


axios_myrewards.interceptors.request.use(
    async (config) => {
        try {
            let TOKEN = localStorage.getItem("token_rewards");
            let accessToken = null;

            if (TOKEN && !isTokenExpired(TOKEN)) {
                accessToken = JSON.parse(TOKEN).access_token;
            } else {
                accessToken = await refreshToken();
            }

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }

            return config;
        } catch (error) {
            return Promise.reject(error);
        }
    },
    (error) => Promise.reject(error)
);


axios_myrewards.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newAccessToken = await refreshToken();

                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                return axios_myrewards(originalRequest);
            } catch (tokenError) {
                console.error("Retry failed:", tokenError);

                localStorage.clear();
                window.location.href = "/auth/sso-login";

                return Promise.reject(tokenError);
            }
        }

        return Promise.reject(error);
    }
);

export default axios_myrewards;